import React, { useEffect } from 'react'
import styles from '../styles'
import { withStyles, Typography } from '@material-ui/core'

import { useSelector } from 'react-redux'
import CustomizedSwitch from 'src/components/customized-switch'
import { PatchContent, PatchData } from 'src/model/patch'
import { patchCollectionSettingsAction } from 'src/reducers/collection/action'
import { CoreFormLayout, CoreTextField } from 'src/components/core'
const MailPreparation = props => {
  const {
    entity,
    collectionSettings,
    dispatch,
    handleSendLinkToNewMembersOnly,
    sendLinkToNewMembersOnly,
    emailText,
    setEmailText,
    emailTitle,
    setEmailTitle,
    classes,
  } = props

  const [hasTeamsToView, setHasTeamsToView] = React.useState(false)

  const [teamListLength, setTeamListLength] = React.useState(0)
  const [memberListLength, setMemberListLength] = React.useState(0)
  const [selectedDomain, setSelectedDomain] = React.useState({
    id: '',
    domain: '',
  })
  const [domainList, setDomainList] = React.useState([])
  const onBlur = value => {
    if (collectionSettings.inviteEmailBody !== value) {
      const patchSource = new PatchData(null, entity.id)
      patchSource.addContent(
        new PatchContent(value, 'inviteEmailBody', PatchData.OPERATION_REPLACE),
      )

      dispatch(patchCollectionSettingsAction(patchSource, response => {}))
    }
  }

  const domainRawList = useSelector(state => state.domain.list.results)

  const domainListCreator = () => {
    const list = []

    domainRawList.map(domain => {
      if (
        domain.defaultCollectionDto &&
        domain.defaultCollectionDto.id === entity.id &&
        domain.verificationStatus === 1
      ) {
        list.push(domain)
      }
    })
    return list
  }
  useEffect(() => {
    const result = domainRawList && domainListCreator()
    setDomainList(result)
  }, [])

  useEffect(() => {
    setHasTeamsToView(true)
  }, [collectionSettings.teams])

  const onBlurEmailTitle = value => {
    if (collectionSettings.invite_member_subject !== value) {
      const patchSource = new PatchData(null, entity.id)
      patchSource.addContent(
        new PatchContent(
          value,
          'inviteEmailSubject',
          PatchData.OPERATION_REPLACE,
        ),
      )

      dispatch(patchCollectionSettingsAction(patchSource, response => {}))
    }
  }
  return (
    <>
      <CoreFormLayout
        direction="column"
        width="50%"
        justifyContent="center"
        alignItems="center"
        itemsPerRow={1}
        itemGap="0px"
      >
        <CoreTextField
          label="Email Subject"
          variant="outlined"
          multiline
          fullWidth
          value={emailTitle}
          onChange={e => setEmailTitle(e.target.value)}
          onBlur={e => onBlurEmailTitle(e.target.value)}
        />
      </CoreFormLayout>
      <Typography color="#637381" fontWeight={500} fontSize={'14px'}>
        You can customize the invitation email below. A personalized, unique
        link for each user will be automatically included.
      </Typography>
      <CoreFormLayout
        direction="column"
        width="100%"
        justifyContent="center"
        alignItems="center"
        itemsPerRow={1}
        itemGap="0px"
      >
        <CoreTextField
          label="Email Body"
          variant="outlined"
          multiline
          rows={10}
          fullWidth
          value={emailText}
          onChange={e => setEmailText(e.target.value)}
          onBlur={e => onBlur(e.target.value)}
        />
      </CoreFormLayout>
      <div className={classes.borderBottom}></div>

      <Typography color="#637381" fontWeight={500} fontSize={'14px'}>
        You have assigned{' '}
        <strong>
          {teamListLength} {teamListLength > 1 ? 'teams' : 'team'}{' '}
        </strong>{' '}
        to this learning path.
      </Typography>

      <div className={classes.sendLinkToNewMembersOnlyContent}>
        <CustomizedSwitch
          id="sendLinkToNewMembersOnly"
          checked={sendLinkToNewMembersOnly}
          onChange={() =>
            handleSendLinkToNewMembersOnly(!sendLinkToNewMembersOnly)
          }
        />
        <Typography fontSize={'15px'} fontWeight={500}>
          Send link to new members only
        </Typography>
      </div>
    </>
  )
}

export default withStyles(styles)(MailPreparation)
